<script>
import localSave  from './../../../utils/local-save'
import { trialDays } from './../../../configuration'
import paywallTracker from '@services/mixpanel/paywall-tracker'
import {
    WALL_TYPES,
    PRESENTATION_TYPES,
    TRIGGER_REASONS,
    ENTRY_POINTS,
    CTA_TYPES,
    DISMISS_METHODS
} from '@services/mixpanel/analytics-spec'

export default {
    name: 'PremiumWelcome',
    data() {
        return {
            trialDays,
        }
    },
    computed: {
        entitledFreeTrial() {
            return !this.$store.getters['premium/hasEverBeenPremium']
        },
    },
    mounted() {
        paywallTracker.onWallShown({
            wallType: WALL_TYPES.PREMIUM_WELCOME,
            presentation: PRESENTATION_TYPES.PAGE,
            triggerReason: TRIGGER_REASONS.USER_INITIATED,
            entryPoint: this._getEntryPoint()
        })
    },
    methods: {
        _getEntryPoint() {
            const query = this.$route.query
            if (query.from === 'topbar') return ENTRY_POINTS.TOP_BAR
            if (query.from === 'sidebar') return ENTRY_POINTS.SIDEBAR
            if (query.from === 'settings') return ENTRY_POINTS.SETTINGS_AUDIO_QUALITY
            if (query.from === 'account') return ENTRY_POINTS.ACCOUNT_MENU
            return ENTRY_POINTS.DIRECT_NAVIGATION
        },
        onUpgradeClick() {
            paywallTracker.onCtaTapped(
                this.entitledFreeTrial ? CTA_TYPES.START_TRIAL : CTA_TYPES.UPGRADE
            )
            this.$router.push(this.$route.path + '/view-plans')
        },
        skipPremiumOnboarding() {
            paywallTracker.onWallDismissed(DISMISS_METHODS.CLOSE)
            localSave.save('hasSkippedPremiumOnboarding', true)
            if (this.$router.history.current.path !== '/') {
                this.$router.back()
            } else {
                this.$router.push({ path: '/' })
            }
        },
    }
}
</script>

<template>
    <div :class="$style.welcome">
        <div :class="$style.welcomeBackground" />
        <BaseSection padded>
            <h1 :class="$style.mainHeader">Go Premium</h1>
            <div :class="$style.description">
                <p :class="$style.descriptionText">{{ entitledFreeTrial ? 'Unlock Hi-Fi sound, zero ads and offline mixes - free for your first month.' : 'Unlock Hi-Fi sound, zero ads and offline mixes.' }}</p>
                <ul :class="$style.salesPoints">
                    <li>Hi-Fi sound</li>
                    <li>No ads</li>
                    <li>Stream radio channels in external players and devices</li>
                    <li>Download mixes & listen offline anywhere on our mobile apps</li>
                    <li>VIP access: Skip the line and access new mixes before everyone else</li>
                </ul>
            </div>
            <div :class="$style.actionsContainer">
                <div :class="$style.welcomeButton">
                    <BaseButton
                        button-type="highlight"
                        @click="onUpgradeClick"
                    > {{ entitledFreeTrial ? `Start ${trialDays}-Day Free Trial` : 'Upgrade Now' }} </BaseButton>
                </div>
                <span
                    :class="$style.escapeUrl"
                    @click="skipPremiumOnboarding"
                ><div>Maybe later - I like ads and low quality sound</div></span>
            </div>
        </BaseSection>
    </div>
</template>

<style lang="scss" module>
@use '@design' as *;

.welcome {
    margin-top: $s-xs;
}

.welcomeBackground {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: url('/images/dj-vibing-purple-gradient.jpg');
    background-position: center;
    background-size: cover;
    opacity: 0.08;

    &.standalone {
        position: fixed;
    }
}

.mainHeader {
    @include h3;

    margin-bottom: 0;  // Remove all bottom margin
    letter-spacing: -0.5px;
}

.subtitle {
    @extend %h5;
}

.description {
    margin-top: 0;
}

.actionsContainer {
    position: relative;
    margin-top: $s-xxl;
}

.salesPoints {
    @extend %contentSubtitleL;

    padding: 0;
    margin-top: $s-xl;
    font-size: 15px;
    line-height: 20px;
    text-align: left;
    list-style: inside;
}

.escapeUrl {
    @extend %contentSubtitleM;

    text-align: center;
    text-decoration: underline;
    cursor: pointer;
}

.descriptionText {
    @extend %h6;

    font-weight: 400;
    color: $c-nevada-grey;
}

@include tablet {
    .actionsContainer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }

    .escapeUrl {
        text-align: left;
    }
}

@include desktop {
    .welcome {
        margin-top: $s-h;
    }

    .mainHeader {
        @include h1;

        margin-bottom: $s-xxl;
    }

    .actionsContainer {
        margin-top: $s-h;
    }
}
</style>
